import { readAllData, STORES } from "utility"
import { getByIdOffline } from "./Get_one"
import { mergeUpsertOffline } from "./crud"
import { buildFullName } from "./queue"
import dayjs from "dayjs"

export async function getBilansOffline({ page = 1, limit = 20, filters }) {
  let data = await readAllData(STORES.BILANS)

  // 🔁 Recouper patient + fullName
  data = await Promise.all(
    data.map(async (b) => {
      let patient = b.patient

      if (!patient || typeof patient !== "object") {
        patient = await getByIdOffline(STORES.PATIENTS, b.patientId)
      }

      return {
        ...b,
        patient,
        fullName: b.fullName || buildFullName(patient),
      }
    }),
  )

  // 🔍 Filter fullName
  if (filters.fullName) {
    const search = filters.fullName.toLowerCase()
    data = data.filter((b) => b.fullName?.toLowerCase().includes(search))
  }

  // 📅 Filter date
  if (filters.startDate) {
    const start = dayjs(filters.startDate).startOf("day").toDate()
    data = data.filter((c) => {
      const d = c.creationDate || c.createdAt
      return d && new Date(d) >= start
    })
  }

  if (filters.endDate) {
    const end = dayjs(filters.endDate).endOf("day").toDate()
    data = data.filter((c) => {
      const d = c.creationDate || c.createdAt
      return d && new Date(d) <= end
    })
  }
  // 📄 Pagination
  const totalItems = data.length
  const start = (page - 1) * limit
  return {
    data: data.slice(start, start + limit),
    totalItems,
  }
}

export async function getAllTestsOffline() {
  return await readAllData(STORES.TESTS)
}

export async function createBilanOffline(body) {
  const tempId = crypto.randomUUID()

  let patient = null
  let fullName = ""
  if (body.patientId) {
    try {
      patient = await getByIdOffline(STORES.PATIENTS, body.patientId)
      fullName = buildFullName(patient)
    } catch (_) {
      // best-effort
    }
  }

  const bilan = {
    ...body,
    id: tempId,
    patient,
    fullName,
    creationDate: new Date().toISOString(),
    __offline: true,
  }

  await mergeUpsertOffline(STORES.BILANS, bilan, { markOffline: true })
  return { ...body, id: tempId, __offline: true }
}
